import { createRequest } from "helpers/tools";

export const getDestinationStatus = async (tracker_id, destination_id, val) => {
    return await createRequest({
        suffix: `trackers/${tracker_id}/destinations/${destination_id}/status/${val}`,
        method: "get",
        handleError: false,
    });
};
